import { IChingTrigramId } from './iching.models';

/**
 * De acht paleizen van Jing Fang (八宮): per zuiver hexagram de acht leden in
 * de klassieke volgorde (het paleishoofd, dan de vijf generaties, het ziel- en
 * het wereld-terugkeerhexagram). Identiek aan Wilhelms "acht huizen"
 * (`houses` in `wilhelm-nl/general.json`); de spec vergelijkt beide.
 */
export const ICHING_PALACES: ReadonlyArray<{ readonly trigram: IChingTrigramId; readonly members: readonly number[] }> = [
  { trigram: 'qian', members: [1, 44, 33, 12, 20, 23, 35, 14] },
  { trigram: 'kan', members: [29, 60, 3, 63, 49, 55, 36, 7] },
  { trigram: 'gen', members: [52, 22, 26, 41, 38, 10, 61, 53] },
  { trigram: 'zhen', members: [51, 16, 40, 32, 46, 48, 28, 17] },
  { trigram: 'xun', members: [57, 9, 37, 42, 25, 21, 27, 18] },
  { trigram: 'li', members: [30, 56, 50, 64, 4, 59, 6, 13] },
  { trigram: 'kun', members: [2, 24, 19, 11, 34, 43, 5, 8] },
  { trigram: 'dui', members: [58, 47, 45, 31, 39, 15, 62, 54] },
];
